import { Vectorizer, util, V, attributes } from "@clientio/rappid";

export function getSelectionAttrs(
  range: { start: number; end: number },
  annotations: Vectorizer.TextAnnotation[]
): attributes.SVGAttributes {
  const start = range.start;
  const end = range.end;

  if (start === end && start === 0) {
    // If the cursor is right at the beginning of the text (and there is *some* text), take
    // attributes from the first character.
    return getCombinedAnnotationAttrsAtIndex(start, annotations);
  } else if (start === end) {
    // Nothing is selected. We take attributes of the character before the current caret position.
    return getCombinedAnnotationAttrsAtIndex(start - 1, annotations);
  } else {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let commonAttrs: any;
    for (let i = start; i < end; i++) {
      let attrs = getCombinedAnnotationAttrsAtIndex(i, annotations);
      if (commonAttrs && !util.isEqual(commonAttrs, attrs)) {
        // Attributes differ. Remove those that differ from commonAttrs.
        commonAttrs = util.flattenObject(V.mergeAttrs({}, commonAttrs));
        attrs = util.flattenObject(V.mergeAttrs({}, attrs));
        const result = {};
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        util.forIn(attrs, function (value, key) {
          if (commonAttrs[key] === attrs[key]) {
            util.setByPath(result, key, value);
          }
        });
        commonAttrs = result;
      } else {
        commonAttrs = attrs;
      }
    }
    return commonAttrs;
  }
}

export function getCombinedAnnotationAttrsAtIndex(
  selectionStart: number,
  annotations: Vectorizer.TextAnnotation[]
): attributes.SVGAttributes {
  const attrs = {};
  util.toArray(annotations).forEach(function (annotation) {
    if (annotation.start === undefined && annotation.end === undefined) {
      // The annotation does not have `start` and `end`. Assume it spans
      // the whole text. This allows us to pass default annotations
      // for text that is not spanned by any regular annotation.
      V.mergeAttrs(attrs, annotation.attrs);
    } else if (selectionStart >= annotation.start && selectionStart < annotation.end) {
      V.mergeAttrs(attrs, annotation.attrs);
    }
  });
  return attrs;
}
